import { Box, Divider, Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import Title from "../../components/common/Title";
import Layout from "../../components/layout/Layout";
import TopBarGridContainer from "../../components/layout/TopBar";
import { TaskArgGenerator } from "./TaskArgGenerator";

/**
 * DevTools component provides a user interface for development tools, primarily
 * featuring a tabbed navigation system that allows users to switch between different
 * development utilities. Currently, it includes a "Task Argument Generator" tool.
 *
 * @returns {JSX.Element} The DevTools component rendered as part of the application layout.
 */
function DevTools() {
  const [tabSection, setTabSection] = useState("TaskArgumentGenerator");

  const DisplayTool = ({ toolSelected }) => {
    switch (toolSelected) {
      case "TaskArgumentGenerator":
        return <TaskArgGenerator />;
      default:
        return <>No tool found for selection.</>;
    }
  };

  const handleChangeTab = (event, newValue) => {
    setTabSection(newValue);
  };

  return (
    <Layout>
      <TopBarGridContainer>
        <Grid size="grow">
          <Title text={"DEVELOPMENT TOOLS"} sx={{ my: 5 }} />
        </Grid>
        <Grid size="grow">
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              mt: 5,
            }}
          >
            <Tabs value={tabSection} sx={{ pr: 10 }} onChange={handleChangeTab}>
              <Tab label="Task Argument Generator" value="TaskArgumentGenerator" />
            </Tabs>
          </Box>
        </Grid>
      </TopBarGridContainer>
      <Divider variant="middle" />

      <DisplayTool toolSelected={tabSection}></DisplayTool>
    </Layout>
  );
}

export default DevTools;
